import { render, staticRenderFns } from "./ListDiss.vue?vue&type=template&id=79a45b0d&scoped=true"
import script from "./ListDiss.vue?vue&type=script&lang=js"
export * from "./ListDiss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a45b0d",
  null
  
)

export default component.exports